// import { upload } from "@testing-library/user-event/dist/upload";
// import React from "react";
// import classNames from "../../classNames";
// import { saveFileUseCase } from "../../domain/file";
// // import { saveFileUseCase } from "../../domain/file";

// const defaultProps = {
//   object: {},
// };

// function InputFileSupport({ className, field, object, ...props }) {
//   const classes = classNames("form-control", className);
//   const value = object[field];

//   function onChange(e) {
//     const files = Array.prototype.slice.call(e.target.files);
//     console.log("files", files);
//     if (files.length > 0) {
//       let images = [];

//       for (let item = 0; item < files.length; item++) {
//         saveFileUseCase()
//           .execute(files[item])
//           .then((result) => {
//             console.log("result", result);
//             images.push(result.url);
//             object[field] = images;
//           })
//           .catch((error) => {
//             console.log(error);
//           });
//       }
//     }
//   }

//   return (
//     // <input
//     //   type="file"
//     //   defaultValue={value}
//     //   className={classes}
//     //   name={field}
//     //   onChange={onChange}
//     //   multiple
//     //   {...props}
//     // />
//     <div className={classes}>
//       <input
//         id={id}
//         type="file"
//         className="d-none" // or 'visually-hidden'
//         onChange={handleChange}
//         multiple
//         accept="image/*"
//         {...props}
//       />
//       <label htmlFor={id} className="btn btn-outline-secondary">
//         <i className="bi bi-file-image"></i>
//       </label>
//     </div>
//   );
// }

// InputFileSupport.defaultProps = defaultProps;
// export default InputFileSupport;

import React from "react";
import classNames from "../../classNames";
import { saveFileUseCase } from "../../domain/file";

function InputFileSupport({ className, field, object, onChange, ...props }) {
  const classes = classNames(className);
  const id = React.useId();

  async function handleChange(e) {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    try {
      const urls = await Promise.all(
        files.map((f) =>
          saveFileUseCase()
            .execute(f)
            .then((r) => r.url)
        )
      );
      const next = [...(object[field] || []), ...urls];
      if (onChange) onChange(field, next);
      else object[field] = next; // fallback if you're mutating props
    } catch (err) {
      console.error(err);
    } finally {
      e.target.value = ""; // reset so same file can re-upload
    }
  }

  return (
    <div className={classes} htmlFor={id}>
      <input
        id={id}
        type="file"
        className="d-none" // or 'visually-hidden'
        onChange={handleChange}
        multiple
        accept="image/*"
        {...props}
      />
      <label htmlFor={id}>
        <i className="bi bi-file-image"></i>
      </label>
    </div>
  );
}

export default InputFileSupport;
